"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLang = getLang;
exports.i18n = i18n;
exports.$ = i18n;
exports.i18n = i18n;
exports.$ = i18n;
const locales_1 = require("@/locales");
const global_1 = require("./global");
const defaultLang = "zh-cn";
function getLang() {
    const settings = JSON.parse(window.localStorage.getItem(global_1.settingsStorageKey));
    if (!settings || !Object.keys(settings).includes("language")) {
        return defaultLang;
    }
    return settings["language"];
}
/**
 * I18n string getter
 *
 * @param key The key of the locale string
 * @returns {string} The locale string
 */
function i18n(key) {
    var _a;
    const lang = getLang();
    const locale = (0, locales_1.getLocale)(lang);
    return (_a = locale[key]) !== null && _a !== void 0 ? _a : key;
}
